import { Stack, Typography } from "@mui/material";
import moment from "moment";
import CustomDialogFooter from "../../../shared/components/CustomDialogFooter";

export const DeleteCustomDateDiaog = (props) => {
  const { templates, onDeleteTagSelect, onSaveCustomDays } = props;

  return (
    <>
      <Stack px="24px" gap="16px">
        <Typography fontWeight={600} fontSize="16px">
          Are you sure you want to remove date "
          {moment(templates.selectedDate).format("DD MMM YYYY")}"?
        </Typography>
        <Typography>
          The date will be removed from your production schedule. You can add
          dates again later.
        </Typography>
      </Stack>

      <CustomDialogFooter
        handleClose={() => onDeleteTagSelect(false)}
        onSubmit={onSaveCustomDays}
        submitButton="Delete"
        cancelButton="Close"
        submitButtonColor="error"
      />
    </>
  );
};
